export default {
  metrics: {
    pickup: 'Afhentning',
    internal_delivery: 'Intern levering',
    external_delivery: 'Ekstern levering',
  },
  events: {
    add_to_basket: 'Tilføj vare',
    begin_checkout: 'Gå til kassen',
    begin_purchase: 'Start betaling',
    complete_purchase: 'Gennemfør betaling',
    order_placed: 'Gennemfør betaling',
    view_item: 'Se vare',
  },
};
